import { createAction } from '@reduxjs/toolkit';
import { IShopCatalog } from 'src/services';

export const useCatalogManagerWSActions = {
  create: createAction<{ catalog: IShopCatalog }>('UseCatalogManagerWS/Create'),
  update: createAction<{ catalog: IShopCatalog }>('UseCatalogManagerWS/Update'),
  delete: createAction<{ id: string }>('UseCatalogManagerWS/Delete'),
  notification: createAction<{ customMessage: string }>('UseCatalogManagerWS/Notification'),
};
